class ClientRegistrationUsersController {
    static controller($scope, $state, ClientRegistrationService) {
      'ngInject';

      $scope.policyChecked = false;
      $scope.proceedRegistration = function(clientRegistration) {
        console.log('proceedRegistration', clientRegistration);
        if(clientRegistration.$valid) {
          // $state.go('public.users.client.client-registration-continue' , {registrationDataStep1 : clientRegistration});

          var  promise = ClientRegistrationService.register(clientRegistration);
          
          promise.then(function(data) {
            $state.go('public.users.client.client-registration-confirm', {userName : clientRegistration.email.$modelValue});
          });
        }
      };
    };
}

export default ClientRegistrationUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/client/client-registration.users.controller.js